const loginValidator = props => {
    // Destructured props
    const {formValues} = props;

    // Actual form field validator for the first step
    const validateForm = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // The regexes for the value to be validated from
        const emailRegex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");

        // Validates each field
        switch (target) {
            case "email":
                if (!value) {
                    errors.email = "Esse campo é obrigatório.";
                } else if (value && !emailRegex.test(value)) {
                    errors.email = "Insira um endereço de email válido.";
                } else if (value.endsWith(".co")) {
                    errors.email = "Insira um endereço de email válido.";
                } else {
                    errors.email = "";
                }

                break;
            case "password":
                if (!value) {
                    errors.password = "Esse campo é obrigatório.";
                } else if (value && value.length < 8) {
                    errors.password = "Sua senha deve possuir no mínimo 8 caracteres.";
                } else {
                    errors.password = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Method to perform a validation in all fields at once
    const validateAll = () => {
        let errors = {};

        // Iterates through each field validating them
        Object.keys(formValues).forEach(key => {
            const args = {
                target: key,
                value: formValues[key]
            }

            errors = {
                ...errors,
                ...validateForm(args)
            }
        })

        // Returns the errors object to be set into the errors state
        return errors;
    }

    return {
        validateForm,
        validateAll
    }
}

export default loginValidator;
